import { render, staticRenderFns } from "./rel-receita-complementar.vue?vue&type=template&id=0e7a6ba9&scoped=true&"
import script from "./rel-receita-complementar.vue?vue&type=script&lang=js&"
export * from "./rel-receita-complementar.vue?vue&type=script&lang=js&"
import style0 from "./rel-receita-complementar.vue?vue&type=style&index=0&id=0e7a6ba9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7a6ba9",
  null
  
)

export default component.exports